import React from 'react';
import { Box, Typography } from '@mui/material';

interface ChartLegendProps {
  bottomDescription?: string;
  subPoints?: string[];
  colors?: string[];
}

const ChartLegend: React.FC<ChartLegendProps> = ({
  bottomDescription,
  subPoints,
  colors = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#06B6D4']
}) => {
  if (!bottomDescription && !subPoints?.length) {
    return null;
  }

  return (
    <>
      {bottomDescription && (
        <Box sx={{ 
          textAlign: 'center', 
          mb: 0.5,  
          mt: 0.5,
          py: 1,
          backgroundColor: '#F9FAFB',
          borderRadius: '8px',
          border: '1px solid #E5E7EB'
        }}>
          <Typography variant="body2" sx={{ 
            fontSize: 13, 
            fontWeight: 500,
            color: '#374151',
            letterSpacing: '0.01em'
          }}>
            {bottomDescription}
          </Typography>
        </Box>
      )}
      {subPoints && subPoints.length > 0 && (
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'row', 
          flexWrap: 'wrap',
          justifyContent: 'left',
        //   gap: 1.5,
          transition: 'all 0.3s ease-in-out',
        }}>
          {subPoints.map((point: string, idx: number) => (
            <Box 
              key={point} 
              sx={{ 
                display: 'flex', 
                alignItems: 'center',
                gap: 1,
                px: 1.5,
                py: 0.6,
                borderRadius: '8px',
                backgroundColor: 'rgba(0, 0, 0, 0.02)',
                cursor: 'pointer',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                  backgroundColor: 'rgba(59, 130, 246, 0.08)',
                  transform: 'translateY(-3px) scale(1.02)',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  '& > div:first-of-type': {
                    transform: 'scale(1.2)',
                    boxShadow: `0 0 0 4px ${colors[idx % colors.length]}30`
                  }
                }
              }}
            >
              <Box sx={{ 
                width: 12, 
                height: 12, 
                borderRadius: '50%', 
                backgroundColor: colors[idx % colors.length],
                boxShadow: `0 0 0 3px ${colors[idx % colors.length]}20`,
                transition: 'all 0.2s ease-in-out'
              }} />
              <Typography variant="body2" sx={{ 
                fontSize: 14, 
                fontWeight: 500,
                color: '#1F2937',
                whiteSpace: 'nowrap'
              }}>
                {point}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </>
  );
};

export default ChartLegend;
